import { Space } from 'antd'
import './index.scss'
import Container from './Container'
import { Link } from 'react-router-dom'

export const Footer = () => {
    return (
        <Container>
            <footer className="footer">
                <div className="footer-content">
                    <div className="footer-left">
                        <p className="copyright">© 2025 - Moodra</p>
                        <p className="rights">All rights reserved</p>
                    </div>
                    <Space className="footer-links" size={24}>
                        <Link to="/privacy-policy">Privacy Policy</Link>
                    </Space>
                </div>
            </footer>
        </Container>
    )
}
